import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import HireneuronTableClient from "./HireneuronTableClient";
import HireneuronTableBody from "./HireneuronTableBody";
import ReactPaginate from "react-paginate";
import HireneuronConfig from "./HireneuronConfig";
import HireneuronSearch from "./HireneuronSearch";
import HireneuronToolTip from "./HireneuronToolTip";
import "../../assets/basicTheme/css/assessment.css";
import "../../assets/scss/custom/components/HireneuronTable.scss";

import LoaderErrorSuccess from "../../pages/Common/loaderErrorSuccess";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardTitle,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import erroricon from "../../assets/images/error-icon.jpg";
import {
  independentFunction,
  verifyData,
} from "../../pages/Common/CommonFunctions/commonFunctions";
import moment from "moment-timezone";
import ReactTooltip from "react-tooltip";
import {
  REST_API_GET_CANDIDATE_LIST,
  REST_API_GET_JOB_PROFILE_SUGGESTION,
  SEARCH_SUGGESTION_DATA,
} from "../../common/constant/constantURL";
import Spiner from "../Common/Spiner";

/**
 *  This is custum table component
 */
let counter = 0;
let mouseDown = false;
let curCol = null;
let nextCol = null;
let curColOriginalWidth = 0;
let nextColOriginalWidth = 0;
let cursorInitialPosition = 0;

const HireneuronTable = (props) => {
  const [tableData, setTableData] = useState([]);
  const [paginationShow, setPaginationShow] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const observer = useRef();
  const [apiUrl, setApiUrl] = useState("");
  const [tableKey, setTableKey] = useState("");
  const [tableHeading, setTableHeading] = useState("");
  const [tableSubHeading, setTableSubHeading] = useState("");
  const [searchButton, setSearchButton] = useState(false);
  const [searchPlaceHolder, setSearchPlaceHolder] = useState("Search");
  const [filterButton, setFilterButton] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [searchSuggestion, setSearchSuggestion] = useState(false);
  const [columns, setColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [paginationType, setPaginationType] = useState(
    HireneuronConfig.paginationType.PAGINATION,
  );
  const [page, setPage] = useState(null);
  const [pageSize, setPageSize] = useState(0);
  const [pageSizes, setPageSizes] = useState([10, 20, 40, 50, 100, 150, 200]);
  const [keyword, setKeyword] = useState("");
  const [keywordS, setKeywordS] = useState("");
  const [filters, setFilters] = useState({});
  const [filtersS, setFiltersS] = useState({});
  const [startRow, setStartRow] = useState(0);
  const [endRow, setEndRow] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsFor, setSuggestionsFor] = useState("");
  const [showHideColumn, setShowHideColumn] = useState(false);
  const [sortOnColumn, setSortOnColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [showColumnChanger, setShowColumnChanger] = useState(false);
  const [selectedFacets, setSelectedFacets] = useState(null);
  const [resetFacets, setResetFacets] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [error, setError] = useState("");
  const [sweet_timer, setSweet_timer] = useState(false);
  const [defaultFilters, setDefaultFilters] = useState([]);
  const [disableFilterButton, setDisableFilterButton] = useState(true);
  const [startDateS, setStartDateS] = useState("");
  const [endDateS, setEndDateS] = useState("");
  const [lastApiSuffix, setLastApiSuffix] = useState(null);
  const [loader, setLoader] = useState(false);
  const [dataApiResponse, setDataApiResponse] = useState({});
  const [scroll, setScroll] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [count, setCount] = useState(0);
  const lastElementRef = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && tableData.length > 0) {
          counter += 1;
          if (counter < totalPages) {
            handlePageChange(page + 1);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    [tableData],
  );

  //for change in table config when component triggers
  useEffect(() => {
    if (verifyData(props.tableKey)) {
      setTableKey(props.tableKey);
    } else {
      setTableKey("");
    }
    if (props.tableConfig == null || props.tableConfig == undefined) {
      return;
    }
    setScroll(
      props.tableConfig.scroll == null ||
        props.tableConfig.scroll == undefined ||
        props.tableConfig.scroll,
    );
    setColumns(props.tableConfig.columns);
    let vColumns = [];
    let defaultFilter = [];
    props.tableConfig.columns.map((column) => {
      if (column.hide === undefined || column.hide == null || !column.hide) {
        vColumns.push(column.label);
      }
      if (column.dafaultFilter) {
        defaultFilter.push(column.dafaultFilter);
      }
    });
    setDefaultFilters(defaultFilter);
    setVisibleColumns(vColumns);
    setApiUrl(props.tableConfig.apiUrl);

    setTableHeading(
      props.tableConfig.tableHeading == null ||
        props.tableConfig.tableHeading == undefined
        ? ""
        : props.tableConfig.tableHeading,
    );
    setTableSubHeading(
      props.tableConfig.tableSubHeading == null ||
        props.tableConfig.tableSubHeading == undefined
        ? ""
        : props.tableConfig.tableSubHeading,
    );
    setSearchButton(
      props.tableConfig.searchButton == null ||
        props.tableConfig.searchButton == undefined
        ? false
        : props.tableConfig.searchButton,
    );
    setSearchPlaceHolder(
      verifyData(props.tableConfig.searchPlaceHolder)
        ? props.tableConfig.searchPlaceHolder
        : "Search",
    );
    setFilterButton(
      props.tableConfig.filterButton == null ||
        props.tableConfig.filterButton === undefined
        ? false
        : props.tableConfig.filterButton,
    );
    setShowHideColumn(
      props.tableConfig.showHideColumn == null ||
        props.tableConfig.showHideColumn === undefined
        ? false
        : props.tableConfig.showHideColumn,
    );
    setSearchSuggestion(
      props.tableConfig.searchSuggestion == null ||
        props.tableConfig.searchSuggestion === undefined
        ? false
        : props.tableConfig.searchSuggestion,
    );
    setPaginationType(
      props.tableConfig.paginationType == null ||
        props.tableConfig.paginationType === undefined
        ? HireneuronConfig.paginationType.PAGINATION
        : props.tableConfig.paginationType,
    );
    if (
      props.tableConfig.pageSizes != null &&
      props.tableConfig.pageSizes !== undefined
    ) {
      setPageSizes(props.tableConfig.pageSizes);

      if (verifyData(props.tableConfig.defaultPageSizeIndex)) {
        setPageSize(
          props.tableConfig.pageSizes[props.tableConfig.defaultPageSizeIndex],
        );
      } else {
        setPageSize(props.tableConfig.pageSizes[0]);
      }
    } else {
      setPageSize(pageSizes[3]);
    }
    if (
      props.tableConfig.dateFilter !== undefined &&
      props.tableConfig.dateFilter !== null
    ) {
      setShowDateFilter(props.tableConfig.dateFilter);
    }
    setPage(0);
    readUrlParams(vColumns);
    setPaginationShow(
      props.tableConfig.lazyLoading == null ||
        props.tableConfig.lazyLoading == undefined ||
        !props.tableConfig.lazyLoading,
    );
  }, [props.tableConfig]);

  //on change of list data after api call
  useEffect(() => {
    if (verifyData(dataApiResponse.content)) {
      if (!paginationShow && dataApiResponse.number != 0) {
        setTableData((prevList) => [...prevList, ...dataApiResponse.content]);
      } else {
        setTableData(dataApiResponse.content);
        if (props.tableData) {
          props.tableData(dataApiResponse.content);
        }
      }
      setPage(dataApiResponse.number);
      setTotalPages(dataApiResponse.totalPages);
      setStartRow(page * pageSize + 1);
      setEndRow(page * pageSize + dataApiResponse.content.length);
      setTotalRows(dataApiResponse.totalElements);
      if (verifyData(props.showDownloadOptions)) {
        if (dataApiResponse.content.length > 0) {
          props.showDownloadOptions(true);
        } else if (dataApiResponse.content.length === 0) {
          props.showDownloadOptions(false);
        }
      }
      if (props.responseHandler != undefined) {
        props.responseHandler(dataApiResponse, resetFacets);
        if (resetFacets) {
          setResetFacets(false);
          setSelectedFacets(null);
        }
      }
      if (paginationShow && scroll) {
        if (!verifyData(props.tableId)) {
          window.scroll(0, 0);
        } else {
          if (count > 1) {
            document.getElementById(props.tableId).scrollIntoView({
              block: "end",
              behavior: "smooth",
              inline: "nearest",
            });
          }
        }
      }
    }
  }, [dataApiResponse]);

  //for getting variables from url params
  const readUrlParams = (vColumns) => {
    let params = {};
    const url = new URL(window.location);

    let urlParts = url.toString().split("?");

    if (urlParts.length > 1) {
      let fltrs = {};
      let facets = {};
      urlParts[1].split("&").forEach((param) => {
        let keys = param.split("=")[0];

        let tKey = keys.split("_")[1];

        if (tKey == tableKey || tKey == props.tableKey) {
          let key = keys.split("_")[0];

          if (key == "page") {
            if (
              props.tableConfig.lazyLoading == null ||
              props.tableConfig.lazyLoading == undefined ||
              !props.tableConfig.lazyLoading
            ) {
              setPage(param.split("=")[1]);
            } else {
              setPage(0);
            }
          } else if (key == "pageSize") {
            setPageSize(param.split("=")[1]);
          } else if (key == "keyword") {
            setKeyword(
              decodeURIComponent(param.split("=")[1]).replaceAll("+", " "),
            );
            setKeywordS(
              decodeURIComponent(param.split("=")[1]).replaceAll("+", " "),
            );
          } else if (key == "sort") {
            setSortingOrder(
              decodeURIComponent(param.split("=")[1]).split("[")[0],
            );
            setSortOnColumn(
              decodeURIComponent(param.split("=")[1])
                .split("[")[1]
                .split("]")[0],
            );
          } else if (key == "startDateInMilli") {
            setStartDate(
              moment(Number(param.split("=")[1])).format("YYYY-MM-DD"),
            );
            setStartDateS(
              moment(Number(param.split("=")[1])).format("YYYY-MM-DD"),
            );
          } else if (key == "endDateInMilli") {
            setEndDate(
              moment(Number(param.split("=")[1])).format("YYYY-MM-DD"),
            );
            setEndDateS(
              moment(Number(param.split("=")[1])).format("YYYY-MM-DD"),
            );
          } else if (
            key == "skillFacets" ||
            key == "jobProfileFacets" ||
            key == "educationFacets" ||
            key == "locationFacets"
          ) {
            facets[key] = [
              ...decodeURIComponent(param.split("=")[1])
                .replaceAll("+", " ")
                .split(","),
            ];
          } else if (key == "experienceFacets" || key == "dateRange") {
            facets[key] = decodeURIComponent(param.split("=")[1]).replaceAll(
              "+",
              " ",
            );
          } else if (vColumns.includes(key)) {
            setShowFilters(props.tableConfig.filterButton);
            fltrs[key] = decodeURIComponent(param.split("=")[1]).replaceAll(
              "+",
              " ",
            );
          }
        }
      });
      setFilters(fltrs);
      setDisableFilterButton(Object.keys(fltrs).length === 0);
      let x = {};
      Object.keys(fltrs).forEach(function (key, index) {
        x[key] = fltrs[key];
      });
      setFiltersS(x);
      setSelectedFacets(facets);
      if (props.selectedFacetHandler != undefined) {
        props.selectedFacetHandler(facets);
      }
    }
    return params;
  };

  //for updating url
  const updateUrl = (urlSuffix) => {
    if (tableKey == "") {
      return;
    }
    const url = new URL(window.location);
    Array.from(url.searchParams).map((param) => {
      if (param[0].split("_")[1] == tableKey) {
        url.searchParams.delete(param[0]);
      }
    });
    let urlParts = urlSuffix.split("?");
    if (urlParts.length > 1) {
      urlParts[1].split("&").forEach((param) => {
        url.searchParams.set(
          param.split("=")[0] + "_" + tableKey,
          param.split("=")[1],
        );
      });
    }
    window.history.replaceState(null, "", url.toString());
  };

  //triggers when there is change in page,pageSize,keywords,sorting,dates,checkboxes etc
  useEffect(() => {
    if (verifyData(page) && verifyData(pageSize)) {
      if (props.tableConfig && props.tableConfig.staticData) {
        let data = props.tableConfig.staticData;
        if (keyword) {
          const lowerKeyword = keyword.toLowerCase();
          data = data.filter(
            (c) =>
              (c.fullName || "").toLowerCase().includes(lowerKeyword) ||
              (c.email || c.primaryEmail || "")
                .toLowerCase()
                .includes(lowerKeyword),
          );
        }
        if (sortOnColumn != null && sortingOrder != null) {
          data = [...data].sort((a, b) => {
            let valA = a[sortOnColumn] || "";
            let valB = b[sortOnColumn] || "";
            if (valA < valB) return sortingOrder === "ASC" ? -1 : 1;
            if (valA > valB) return sortingOrder === "ASC" ? 1 : -1;
            return 0;
          });
        }
        let paginated = data.slice(page * pageSize, (page + 1) * pageSize);
        setDataApiResponse({
          content: paginated,
          number: page,
          totalPages: Math.ceil(data.length / pageSize),
          totalElements: data.length,
        });
        return;
      }

      const pageParam =
        props.tableConfig?.pageParam !== undefined
          ? props.tableConfig.pageParam
          : "page";

      let browserUrlSuffix =
        (apiUrl.includes("?") ? `&${pageParam}=` : `?${pageParam}=`) +
        page +
        "&pageSize=" +
        pageSize;

      let apiUrlSuffix =
        (apiUrl.includes("?") ? `&${pageParam}=` : `?${pageParam}=`) +
        page +
        "&pageSize=" +
        pageSize;
      defaultFilters.forEach((defaultFilter) => {
        if (defaultFilter === HireneuronConfig.customFilter.FUTURE_INTERVIEWS) {
          apiUrlSuffix =
            apiUrlSuffix +
            (window.location.pathname.includes("dashboard")
              ? "&futureInterviews=true"
              : "");
        }
      });
      let downloadUrl = "";
      if (keyword != "") {
        apiUrlSuffix = apiUrlSuffix + "&keyword=" + encodeURI(keyword);
        browserUrlSuffix = apiUrlSuffix + "&keyword=" + keyword;
        downloadUrl = downloadUrl + "&keyword=" + keyword;
      } else {
        Object.keys(filtersS).forEach(function (columnName, index) {
          if (!visibleColumns.includes(columnName)) {
            return;
          }
          apiUrlSuffix =
            apiUrlSuffix +
            "&" +
            columnName +
            "=" +
            encodeURI(filters[columnName]);
          downloadUrl =
            downloadUrl +
            "&" +
            columnName +
            "=" +
            encodeURI(filters[columnName]);
          browserUrlSuffix =
            browserUrlSuffix + "&" + columnName + "=" + filters[columnName];
        });
      }
      if (selectedFacets != undefined && selectedFacets != null) {
        if (
          selectedFacets.skillFacets != undefined &&
          selectedFacets.skillFacets.length > 0
        ) {
          apiUrlSuffix =
            apiUrlSuffix +
            "&skillFacets=" +
            selectedFacets.skillFacets
              .map((skill) => encodeURI(skill))
              .join(",");
          browserUrlSuffix =
            browserUrlSuffix +
            "&skillFacets=" +
            selectedFacets.skillFacets.join(",");
        }
        if (
          selectedFacets.jobProfileFacets != undefined &&
          selectedFacets.jobProfileFacets.length > 0
        ) {
          apiUrlSuffix =
            apiUrlSuffix +
            "&jobProfileFacets=" +
            selectedFacets.jobProfileFacets
              .map((skill) => encodeURI(skill))
              .join(",");
          browserUrlSuffix =
            browserUrlSuffix +
            "&jobProfileFacets=" +
            selectedFacets.jobProfileFacets.join(",");
        }
        if (
          selectedFacets.educationFacets != undefined &&
          selectedFacets.educationFacets.length > 0
        ) {
          apiUrlSuffix =
            apiUrlSuffix +
            "&educationFacets=" +
            selectedFacets.educationFacets
              .map((skill) => encodeURI(skill))
              .join(",");
          browserUrlSuffix =
            browserUrlSuffix +
            "&educationFacets=" +
            selectedFacets.educationFacets.join(",");
        }
        if (
          selectedFacets.locationFacets != undefined &&
          selectedFacets.locationFacets.length > 0
        ) {
          apiUrlSuffix =
            apiUrlSuffix +
            "&locationFacets=" +
            selectedFacets.locationFacets
              .map((skill) => encodeURI(skill))
              .join(",");
          browserUrlSuffix =
            browserUrlSuffix +
            "&locationFacets=" +
            selectedFacets.locationFacets.join(",");
        }
        if (
          selectedFacets.experienceFacets != undefined &&
          selectedFacets.experienceFacets != ""
        ) {
          apiUrlSuffix =
            apiUrlSuffix +
            "&experienceFacets=" +
            encodeURI(selectedFacets.experienceFacets);
          browserUrlSuffix =
            browserUrlSuffix +
            "&experienceFacets=" +
            selectedFacets.experienceFacets;
        }
        if (selectedFacets.dateRange != undefined) {
          apiUrlSuffix =
            apiUrlSuffix + "&dateRange=" + encodeURI(selectedFacets.dateRange);
          browserUrlSuffix =
            browserUrlSuffix + "&dateRange=" + selectedFacets.dateRange;
        }
      }
      if (sortOnColumn != null && sortingOrder != null) {
        apiUrlSuffix =
          apiUrlSuffix +
          "&sort=" +
          encodeURI(sortingOrder + "[" + sortOnColumn + "]");
        downloadUrl =
          downloadUrl +
          "&sort=" +
          encodeURI(sortingOrder + "[" + sortOnColumn + "]");

        browserUrlSuffix =
          browserUrlSuffix + "&sort=" + sortingOrder + "[" + sortOnColumn + "]";
      }
      if (verifyData(startDateS) && verifyData(endDateS)) {
        apiUrlSuffix =
          apiUrlSuffix +
          `&startDateInMilli=${new Date(
            startDateS,
          ).getTime()}&endDateInMilli=${new Date(endDateS).getTime()}`;
        downloadUrl =
          downloadUrl +
          `&startDateInMilli=${new Date(
            startDateS,
          ).getTime()}&endDateInMilli=${new Date(endDateS).getTime()}`;
        browserUrlSuffix =
          browserUrlSuffix +
          `&startDateInMilli=${new Date(
            startDateS,
          ).getTime()}&endDateInMilli=${new Date(endDateS).getTime()}`;
      }
      updateUrl(browserUrlSuffix);
      if (
        verifyData(apiUrl) &&
        (apiUrlSuffix != lastApiSuffix || apiUrl !== lastApiUrl)
      ) {
        setLastApiUrl(apiUrl);
        let apiUrlNew;
        if (apiUrl === HireneuronTableClient.CANDIDATE) {
          apiUrlNew = REST_API_GET_CANDIDATE_LIST + apiUrlSuffix + "&type=All";
        } else {
          apiUrlNew = apiUrl + apiUrlSuffix;
        }
        callApi("DATA", apiUrlNew);
        setLastApiSuffix(apiUrlSuffix);
        if (verifyData(props.getDownloadUrl)) {
          props.getDownloadUrl(downloadUrl);
        }
      }
    }
  }, [
    page,
    pageSize,
    keywordS,
    filtersS,
    sortOnColumn,
    sortingOrder,
    selectedFacets,
    startDateS,
    endDateS,
    apiUrl,
  ]);

  const [lastApiUrl, setLastApiUrl] = useState("");

  useEffect(() => {
    if (verifyData(props.refresh)) {
      if (props.refresh) {
        handleRefresh();
      }
    }
  }, [props.refresh]);

  useEffect(() => {
    if (!verifyData(props.refreshCurrent)) {
      return;
    }

    if (verifyData(lastApiSuffix) && verifyData(lastApiUrl)) {
      callApi("DATA", lastApiUrl + lastApiSuffix);
    }

    if (verifyData(props.handleRefreshCurrent)) {
      props.handleRefreshCurrent();
    }
  }, [props.refreshCurrent]);

  //for change in selected checkboxes
  useEffect(() => {
    if (
      props.selectedFacets != undefined &&
      props.selectedFacets != null &&
      props.selectedFacets != "null"
    ) {
      setSelectedFacets(props.selectedFacets);
    }
  }, [props.selectedFacets]);

  const handleKeywordChange = (value, getSuggestions) => {
    setKeyword(value);
    if (getSuggestions) {
      handleGetSuggestion("keyword", value);
    }
  };

  // for handling search
  const handleSearch = () => {
    setFilters({});
    setDisableFilterButton(true);
    setFiltersS({});
    setSelectedFacets({});
    setResetFacets(true);
    setKeywordS(keyword);
    setPage(0);
    setShowFilters(false);
  };

  //for handling columnd hide or show
  const handleColumnHideShow = (columnName) => {
    let newVisibleColumns = [...visibleColumns];
    const index = newVisibleColumns.indexOf(columnName);
    if (index > -1) {
      newVisibleColumns.splice(index, 1);
    } else {
      newVisibleColumns.push(columnName);
    }
    setVisibleColumns(newVisibleColumns);
  };

  // for sorting columns
  const handleSort = (columnName, order) => {
    setSortOnColumn(columnName);
    setSortingOrder(order);
  };

  const handleFilterApply = () => {
    setKeyword("");
    setKeywordS("");
    setSelectedFacets({});
    setResetFacets(true);
    let x = {};
    Object.keys(filters).forEach(function (key, index) {
      x[key] = filters[key];
    });
    setFiltersS(x);
  };

  //for handidng filter conditions
  const handleFilterValue = (
    columnName,
    value,
    filterCondition,
    suggestionsAllowed,
  ) => {
    let newFilters = filters;
    if (typeof value === "string" || value instanceof String) {
      value = value.trim();
    }
    if (value === "" && columnName in newFilters) {
      delete newFilters[columnName];
    } else if (value !== "") {
      newFilters[columnName] = filterCondition + "[" + value + "]";
      if (suggestionsAllowed) {
        handleGetSuggestion(columnName, value);
      }
    }
    setFilters(newFilters);
    setDisableFilterButton(Object.keys(newFilters).length === 0);
  };

  const handleRefresh = () => {
    let vColumns = [];
    props.tableConfig.columns.map((column) => {
      if (column.hide === undefined || column.hide == null || !column.hide) {
        vColumns.push(column.label);
      }
    });
    setVisibleColumns(vColumns);
    setPage(0);
    setPageSize(pageSize);
    setKeyword("");
    setKeywordS("");
    setResetFacets(true);
    setFilters({});
    setFiltersS({});
    setDisableFilterButton(true);
    setSelectedFacets({});
    setSortOnColumn(null);
    setSortingOrder(null);
    setStartDate("");
    setStartDateS("");
    setEndDate("");
    setEndDateS("");
    setLastApiSuffix(null);
    if (verifyData(props.handleRefresh)) {
      props.handleRefresh();
    }
  };

  //for getting suggestions
  const handleGetSuggestion = (column, value) => {
    let hireneuronClient = "";
    if (column === "keyword") {
      hireneuronClient = HireneuronTableClient.SEARCH;
    } else if (column === "jobProfile") {
      hireneuronClient = HireneuronTableClient.JOB_PROFILE;
    } else if (column === "candidateSkillModel") {
      hireneuronClient = HireneuronTableClient.SKILL;
    } else if (column === "skills") {
      hireneuronClient = HireneuronTableClient.SKILL;
    }
    setSuggestionsFor(column);
    let apUrl = "";
    if (!window.location.pathname.includes("job/jd")) {
      apUrl =
        SEARCH_SUGGESTION_DATA +
        `?keyword=${value}&category=${hireneuronClient}`;
    } else {
      apUrl = REST_API_GET_JOB_PROFILE_SUGGESTION + value;
    }
    callApi("SUGGESTION", apUrl);
  };

  //for page size change
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  //for page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  function handleMovement(e) {
    if (mouseDown) {
      e.preventDefault();
      if (verifyData(curCol)) {
        curCol.style.width =
          curColOriginalWidth + e.clientX - cursorInitialPosition + "px";
        if (verifyData(nextCol)) {
          nextCol.style.width =
            nextColOriginalWidth - (e.clientX - cursorInitialPosition) + "px";
          document.body.style.cursor = "e-resize";
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener("mouseup", function (e) {
      mouseDown = false;
      document.body.style.cursor = "default";
      document.removeEventListener("mousemove", handleMovement, true);
    });
  }, []);

  const onMouseDown = (e) => {
    mouseDown = true;
    e.preventDefault();
    curCol = e.target.parentElement.parentElement;
    nextCol = curCol?.nextElementSibling;
    curColOriginalWidth = curCol?.clientWidth;
    nextColOriginalWidth = nextCol?.clientWidth;
    cursorInitialPosition = e.clientX;
    document.addEventListener("mousemove", handleMovement, true);
  };

  const onChangeEndDate = (date) => {
    if (verifyData(startDate)) {
      if (new Date(startDate).getTime() <= new Date(date).getTime()) {
        setEndDate(date);
        setError("");
      } else {
        setSweet_timer(true);
        setEndDate("");
      }
    } else {
      setEndDate(date);
    }
  };

  //for submiiting dates
  const handleValidSubmit = (e, v) => {
    if (verifyData(startDate) && verifyData(endDate)) {
      if (new Date(startDate).getTime() <= new Date(endDate).getTime()) {
        setStartDateS(startDate);
        setEndDateS(endDate);
        setPage(0);
        setError("");
      } else {
        setSweet_timer(true);
      }
    } else {
      setSweet_timer(true);
    }
  };

  //for changing start date
  const onChangeStartDate = (date) => {
    setStartDate(date);
    if (verifyData(endDate)) {
      if (new Date(date).getTime() <= new Date(endDate).getTime()) {
        setStartDate(date);

        setError("");
      } else {
        setSweet_timer(true);
        setStartDate("");
      }
    } else {
      setStartDate(date);
    }
  };

  //for checking dates
  const onClickSubmitDateBtn = () => {
    if (!verifyData(startDate) || !verifyData(endDate)) {
      setError("Please select valid dates");
      setSweet_timer(true);
    }
  };

  const handleCallback = () => {
    props.getHireneuronTableListFailure(null);
    setError("");
  };

  const callApi = (type, url) => {
    if (type == "DATA") {
      setCount(count + 1);
      setLoader(true);
    }
    let headers = {
      "Content-Type": "application/json",
    };
    try {
      var user = JSON.parse(localStorage.getItem("authUser"));
      headers.accesstoken = user.accessToken;
      headers.refreshtoken = user.refreshToken;
    } catch (e) {}

    fetch(process.env.REACT_APP_Domain + url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        }

        throw response.data !== undefined && response.data !== null
          ? response.data
          : response;
      })
      .then((result) => {
        if (result.logout) {
          window.location.href = "/logout";
          return;
        }
        setLoader(false);
        if (type == "DATA") {
          setDataApiResponse(result);
        } else {
          setSuggestions(result);
        }
      })
      .catch((err) => {
        if (err.error && err.statusCode === 403) {
          window.location.href = "/pages-403";
          return;
        }
        if (err.error && err.statusCode === 423) {
          setError(err.error);
        }
      });
  };

  useEffect(() => {
    if (verifyData(startDate) && verifyData(endDate)) {
      if (new Date(startDate).getTime() <= new Date(endDate).getTime()) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    } else {
      setIsButtonDisabled(true);
    }
  }, [startDate, endDate]);
  // gen unique key
  const generateKey = (pre) => {
    return `${pre}_${new Date().getTime()}`;
  };

  return (
    <>
      {sweet_timer ? (
        <SweetAlert
          timeout={2000}
          showConfirm={false}
          onConfirm={() => {
            setSweet_timer(false);
          }}
        >
          <div>
            {
              <img
                src={erroricon}
                style={{ height: "40px" }}
                alt={"error-icon"}
              />
            }
          </div>
          <div className="m-1">Please select valid dates</div>
        </SweetAlert>
      ) : null}
      <Spiner spiner={loader} />

      <LoaderErrorSuccess
        errorMessage={error}
        callback={handleCallback}
      ></LoaderErrorSuccess>

      <div
        className={`${
          visibleColumns.length == 0 ? "table-col-zero-height" : ""
        } ${loader ? "table-opacity" : ""}`}
      >
        <div className="table-header-filter">
          {!showDateFilter ? (
            <div className="left">
              <CardTitle className="h4">{tableHeading}</CardTitle>
              <p className="card-title-desc mb-2">{tableSubHeading}</p>
            </div>
          ) : (
            ""
          )}
          {showDateFilter ? (
            <form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                const values = Object.fromEntries(formData.entries());
                handleValidSubmit(e, values);
              }}
            >
              <div className="d-flex flex-row align-items-center jobs-date-time-new auto-tl">
                <p className="mr-2 mb-0">From</p>
                <div className="hide-error">
                  <input
                    name="startDate"
                    id="as-startdate"
                    className="form-control mr-1"
                    value={independentFunction(
                      startDate !== null,
                      startDate,
                      "",
                    )}
                    onChange={(e) => onChangeStartDate(e.target.value)}
                    type="date"
                  />
                </div>
                <p className="mr-2 ml-2 mb-0">To</p>
                <div className="hide-error">
                  <input
                    name="endDate"
                    id="as-enddate"
                    className="form-control mr-1"
                    value={independentFunction(endDate !== null, endDate, "")}
                    min={startDate}
                    type="date"
                    onChange={(e) => onChangeEndDate(e.target.value)}
                  />
                </div>
                <button
                  id="as-submit"
                  className="btn btn-primary ml-2 mt-3"
                  type="submit"
                  onClick={onClickSubmitDateBtn}
                  disabled={isButtonDisabled}
                >
                  Submit
                </button>
              </div>
            </form>
          ) : (
            ""
          )}
          <div className="right">
            <div
              className="input-group header-search search-input-container"
              hidden={!searchButton}
            >
              <i
                className="fa fa-search search-icon-inside"
                onClick={() => handleSearch()}
              />
              <input
                type="text"
                id="as-search-keyword"
                className="form-control greyish-search"
                placeholder={searchPlaceHolder}
                value={keyword}
                onChange={(e) => handleKeywordChange(e.target.value, true)}
                onKeyUp={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
              <Dropdown
                hidden={searchSuggestion && suggestionsFor === "keyword"}
                isOpen={
                  searchSuggestion &&
                  suggestionsFor === "keyword" &&
                  suggestions.length > 0
                }
                toggle={() => setSuggestions([])}
                className="dropright"
              >
                <DropdownToggle
                  tag="button"
                  className="d-none "
                ></DropdownToggle>
                <div className="dropdown-custom-menu2">
                  <DropdownMenu className="dropdown-menu-left-custom">
                    {suggestions.map((value) => {
                      return (
                        <DropdownItem
                          onClick={() => handleKeywordChange(value, false)}
                          value={value}
                          key={generateKey()}
                        >
                          {value}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </div>
              </Dropdown>
            </div>
            <div className="filter-column-btn">
              <div className="btn-refresh">
                <button
                  id="as-refresh"
                  className="btn  btn-outline-primary"
                  type="button"
                  onClick={() => handleRefresh()}
                  data-tip
                  data-htmlfor="applyRefresh"
                >
                  <i className="fas fa-redo"></i>
                </button>
                <ReactTooltip id="applyRefresh" place="top" effect="solid">
                  Refresh
                </ReactTooltip>
              </div>

              <div className="btn-filter" hidden={!filterButton}>
                <button
                  id="as-filters"
                  className="btn  btn-primary "
                  type="button"
                  onClick={() => setShowFilters(!showFilters)}
                  data-tip
                  data-htmlfor="applyFilter"
                >
                  <i className="fa fa-filter"></i>
                </button>
                <ReactTooltip id="applyFilter" place="top" effect="solid">
                  Apply Filter
                </ReactTooltip>
              </div>

              <div className="btn-columns" hidden={!showHideColumn}>
                <Dropdown
                  isOpen={showColumnChanger}
                  toggle={() => setShowColumnChanger(!showColumnChanger)}
                  className="dropright"
                  id="as-columns-change"
                >
                  <DropdownToggle
                    tag="button"
                    className="btn btn-info "
                    data-tip
                    data-htmlfor="ShowHideColumns"
                  >
                    <i className="fa fa-columns" />
                  </DropdownToggle>
                  <div className="dropdown-custom-menu">
                    <DropdownMenu
                      className="dropdown-menu-right-custom"
                      style={{ overflowY: "scroll" }}
                    >
                      {columns.map((column, index) => {
                        let diabled =
                          (column.hide != null &&
                            column.hide != undefined &&
                            !column.hide) ||
                          index === 0 ||
                          columns.length - 1 === index;
                        return (
                          <div
                            className="form-check form-check-dd"
                            key={generateKey(index)}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={column.label}
                              checked={visibleColumns.includes(column.label)}
                              onChange={() => {
                                handleColumnHideShow(column.label);
                              }}
                              id={
                                "as-sh-column-" +
                                column.name.toLowerCase().replaceAll(" ", "-")
                              }
                              disabled={diabled}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={column.label + index}
                            >
                              {column.name}
                            </label>
                          </div>
                        );
                      })}
                    </DropdownMenu>
                  </div>
                </Dropdown>{" "}
                <ReactTooltip id="ShowHideColumns" place="left" effect="solid">
                  Show or Hide Columns
                </ReactTooltip>
              </div>
            </div>
          </div>
        </div>

        <table
          className="table table-bordered dataTable"
          style={{ width: "100%", maxHeight: props.tableConfig?.tableHeight }}
          id={verifyData(props.tableId) ? props.tableId : "mainTable"}
        >
          <thead>
            <tr>
              {columns.map((column, index) => {
                let sorting =
                  column.sort != undefined &&
                  column.sort != null &&
                  column.sort;
                if (!visibleColumns.includes(column.label)) {
                  return null;
                }
                return (
                  <th
                    key={`thead-${column.label}-${index}`}
                    style={
                      verifyData(column.width)
                        ? { width: column.width + "vw" }
                        : { width: 100 / visibleColumns.length + "vw" }
                    }
                    className={
                      verifyData(column.className)
                        ? `${column.className} p-0`
                        : "p-0"
                    }
                  >
                    <div
                      id={
                        "as-column-" +
                        column.label.toLowerCase().replaceAll(" ", "-")
                      }
                      style={{
                        display: "flex",
                        flexWrap: "nowwrap",
                        position: "relative",
                        padding: "0.75rem 0.75rem",
                        justifyContent: verifyData(column.position)
                          ? column.position
                          : "center",
                        cursor: sorting ? "pointer" : "",
                      }}
                      onClick={() => {
                        if (sorting) {
                          if (
                            sortOnColumn == column.label &&
                            sortingOrder == HireneuronConfig.sortingOrder.ASC
                          ) {
                            handleSort(
                              column.label,
                              HireneuronConfig.sortingOrder.DESC,
                            );
                          } else if (
                            sortOnColumn == column.label &&
                            sortingOrder == HireneuronConfig.sortingOrder.DESC
                          ) {
                            handleSort(
                              column.label,
                              HireneuronConfig.sortingOrder.ASC,
                            );
                          } else {
                            handleSort(
                              column.label,
                              HireneuronConfig.sortingOrder.ASC,
                            );
                          }
                        }
                      }}
                    >
                      <HireneuronToolTip
                        value={column.name}
                        someLongText={column.name}
                      />
                      <div
                        style={{
                          marginLeft: "auto",
                          display: "flex",
                          flexWrap: "nowwrap",
                        }}
                        className="sorting"
                        hidden={!sorting}
                      >
                        <span
                          className={
                            sortOnColumn == column.label &&
                            sortingOrder == HireneuronConfig.sortingOrder.ASC
                              ? "sorting-asc active"
                              : "sorting-asc"
                          }
                          id={
                            "as-asc-" +
                            column.label.toLowerCase().replaceAll(" ", "-")
                          }
                        >
                          <i
                            className="fas fa-long-arrow-alt-up"
                            onClick={() =>
                              handleSort(
                                column.label,
                                HireneuronConfig.sortingOrder.ASC,
                              )
                            }
                          />
                        </span>
                        <span
                          className={
                            sortOnColumn == column.label &&
                            sortingOrder == HireneuronConfig.sortingOrder.DESC
                              ? "sorting-desc active "
                              : "sorting-desc"
                          }
                          id={
                            "as-desc-" +
                            column.label.toLowerCase().replaceAll(" ", "-")
                          }
                        >
                          <i
                            className="fas fa-long-arrow-alt-down"
                            onClick={() =>
                              handleSort(
                                column.label,
                                HireneuronConfig.sortingOrder.DESC,
                              )
                            }
                          />
                        </span>
                      </div>
                      <div
                        hidden={index == columns.length - 1}
                        className="ht-drag"
                        onMouseDown={(e) => {
                          onMouseDown(e);
                        }}
                      ></div>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr hidden={!showFilters || !filterButton}>
              {columns.map((column, index) => {
                if (!visibleColumns.includes(column.label)) {
                  return null;
                }
                return (column.filter != null && column.filter != undefined) ||
                  column.actions ? (
                  <td key={`filter-td-${column.label}-${index}`}>
                    <HireneuronSearch
                      column={column}
                      handleFilterValue={(
                        value,
                        filterCondition,
                        suggestionsAllowed,
                      ) => {
                        handleFilterValue(
                          column.label,
                          value,
                          filterCondition,
                          suggestionsAllowed,
                        );
                      }}
                      handleApply={handleFilterApply}
                      suggestions={suggestions}
                      suggestionsFor={suggestionsFor}
                      filterValue={filters[column.label]}
                      disableFilterButton={disableFilterButton}
                    />
                  </td>
                ) : (
                  <td
                    key={`empty-td-${column.label}-${index}`}
                    className={independentFunction(
                      column.class !== undefined,
                      "th " + column.class,
                      "th",
                    )}
                  >
                    &nbsp;
                  </td>
                );
              })}
            </tr>

            {tableData.length > 0 ? (
              <HireneuronTableBody
                visibleColumns={visibleColumns}
                columns={columns}
                reference={lastElementRef}
                tableData={tableData}
                paginationShow={paginationShow}
              />
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan={12}>No Record Found</td>
              </tr>
            )}
          </tbody>
        </table>

        {paginationShow ? (
          paginationType === HireneuronConfig.paginationType.PAGINATION ? (
            <div className="data-table-bottom">
              <div className="show-enties">
                <span className="mr-1">Show Entries </span>

                <select
                  value={pageSize}
                  onChange={(e) => handlePageSizeChange(e.target.value)}
                  className="entries-select"
                  id="as-page-size"
                >
                  {pageSizes.map((pSize) => (
                    <option key={generateKey(pSize)} value={pSize}>
                      {pSize}
                    </option>
                  ))}
                </select>
              </div>
              {endRow > 0 ? (
                <div className="total-entries" id="as-total-entries">
                  Showing{" "}
                  {startRow +
                    " to " +
                    endRow +
                    " of " +
                    totalRows +
                    " Entries "}
                </div>
              ) : (
                ""
              )}
              <div className="pagination-outer" id="as-table-pagination">
                {tableData.length > 0 && totalPages > 1 && verifyData(page) ? (
                  <ReactPaginate
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={1}
                    onPageChange={(e) => handlePageChange(e.selected)}
                    forcePage={page ? page : 0}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"page-item active"}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <></>
          )
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStatetoProps = null;

export default connect(mapStatetoProps, {})(HireneuronTable);
